
import type { Facet } from '@empathybroker/tsclient-play/dist/models/search/facet'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { EpbButton } from './shared/epb-button'
import TransitionSize from './transition-size.component.vue'

export default defineComponent({
  name: 'FacetsSettingsList',
  components: {
    EpbButton,
    TransitionSize,
  },
  props: {
    facets: {
      type: Array as PropType<Array<Facet>>,
      required: true,
    },
  },
  data() {
    return {
      expandedFacetId: undefined,
    }
  },
  methods: {
    isFacetExpanded(facetId: string): boolean {
      return facetId === this.expandedFacetId
    },
    toggleFacetExpanded(facetId: string): void {
      this.expandedFacetId = !this.isFacetExpanded(facetId) ? facetId : undefined
    },
  },
})
